module.exports = __webpack_public_path__ + "static/landing-img-b-81ecd5481897b3285bdfefb771d456dc.svg";